module.exports = __webpack_public_path__ + "static/media/whitetea.c21d54ed.jpg";